// The six barrier grids. Each is its row of `BARRIER_SCREENS` rendered by the
// one screen component; what differs between them is data, in `barrierViews.ts`.

import { BarrierScreen } from './BarrierScreen';
import { BARRIER_SCREENS } from './barrierViews';

export const BarriersDashboardScreen = () => <BarrierScreen {...BARRIER_SCREENS.barriersDashboard} />;
export const HotScreen = () => <BarrierScreen {...BARRIER_SCREENS.hot} />;
export const PlantsScreen = () => <BarrierScreen {...BARRIER_SCREENS.plants} />;
export const DepartmentScreen = () => <BarrierScreen {...BARRIER_SCREENS.department} />;
export const ArchiveScreen = () => <BarrierScreen {...BARRIER_SCREENS.archive} />;
export const InterplantTransfersScreen = () => <BarrierScreen {...BARRIER_SCREENS.interplantTransfers} />;
